<template>
    <div>
        <my-header></my-header>
        <div class="container">
            <img src="../../assets/img/home_bg.png" alt="" class="top">
            <div class="df content">
                <div class="df info">
                    <img :src="userInfo.Avatar" alt="">
                    <p>No.{{userInfo.JobNo}}</p>
                    <p class="ft20">{{userInfo.NickName}}</p>
                </div>
                <div class="df nav">
                    <router-link tag="div" :to="'/personInfo/original?uid='+userInfo.Id+'&sourceType=2'" @click.native="changeType(2)" :class="{active: nowIndex==2}">原创作品分享</router-link> 
                    <router-link tag="div" :to="'/personInfo/original?uid='+userInfo.Id+'&sourceType=1'" @click.native="changeType(1)" :class="{active: nowIndex==1}">图片素材</router-link> 
                    <router-link tag="div" :to="'/personInfo/original?uid='+userInfo.Id+'&sourceType=3'" @click.native="changeType(3)" :class="{active: nowIndex==3}">ppt</router-link> 
                    <router-link tag="div" :to="'/personInfo/collect?uid='+userInfo.Id" @click.native="changeType(4)" :class="{active: nowIndex==4}">收藏</router-link>
                </div>
            </div>
            <router-view @getNavIndex="getNavIndex"></router-view>
        </div>
        <my-footer></my-footer>
    </div>
</template>
<script>
import { getInfo } from "@/assets/js/modules/userApi"
export default {
    data() {
        return {
            length: 0,
            userInfo: {},
            nowIndex: 2,
            isWaterShow: true
        }
    },
    created() {
        this.getUserInfo();
    },
    methods: {
        getListLength(len) {
            this.length = len;
        },
        getUserInfo() {
            let uid = this.$route.query.uid;
            if (!uid) return;
            let data = { Id: uid };
            getInfo(data).then(res => {
                if (res.data.Success) {
                    this.userInfo = res.data.Data;
                    document.title = this.userInfo.NickName + "的个人主页";
                } else {
                    this.$router.replace("/404");
                }
            }, err => {
                if(err.response && err.response.status === 401){
                    
                }else{
                    this.$router.replace("/404");
                }
            })
        },
        changeType(type){
            this.nowIndex = type;
        },
        getNavIndex(index){
            this.nowIndex = index;
        }
    },
    watch: {
        $route() {
            this.getUserInfo();
        },
    }
}
</script>
<style scoped>
.top {
    display: block;
    width: 100%;
}

.content {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #fff;
}

.info {
    flex-direction: column;
    justify-content: flex-start;
    padding-bottom: 30px;
    align-items: center;
}

.info img {
    width: 135px;
    height: 135px;
    background-color: #e7e7e7;
    border: 6px solid #fff;
    border-radius: 50%;
    margin-top: -78px;
}

.info p {
    margin-top: 10px;
}

.ft20 {
    font-size: 20px;
}
.nav{
    width: 100%;
    justify-content: center;
    font-size: 18px;
    color: #333;
    height: 80px;
    line-height: 80px;
    border-top: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
}
.nav div{
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    margin-right: 15px;
}
.nav div:last-of-type{
    margin-right: 0;
}
.nav div::after{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    transform: scale(0,1);
    transition: transform 0.5s;
    content: "";
    background-color: #6699ff;
}
.nav .active::after{
    transform: scale(1,1);
}
.container {
    background-color: #fbfbfb;
}

.no-pro {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #999;
    text-align: center;
    padding-bottom: 4%;
}

.no-pro img {
    margin-top: 6%;
}

.no-pro p {
    font-size: 18px;
    line-height: 28px;
    margin-top: 2%;
}

.share-btn {
    width: 286px;
    line-height: 38px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid #ff9933;
    box-sizing: border-box;
    margin-top: 2%;
    cursor: pointer;
}

.share-btn:hover {
    color: #fff;
    background-color: #ff9933;
}
</style>



// WEBPACK FOOTER //
// src/components/otherInfo/info.vue